export enum StationRouteTabsEnum {
  Stations = 0,
  Properties = 1,
  Map = 2, // mobile only
  Statistics = 3,
}

export enum StationOptionsEnum {
  Home = 1,
  MeetingPoint = 2,
  AltMeetingPoint = 3,
}
